export type ProductCategoryKeys = (typeof ProductCategoryKey)[keyof typeof ProductCategoryKey];

export const ProductCategoryKey: {
	readonly Confluence: 'confluence';
	readonly Atlas: 'atlas';
	readonly Jira: 'jira';
	readonly JiraServiceManagement: 'jira-servicedesk';
	readonly CustomerServiceManagement: 'jira-customer-service';
} = {
	Confluence: 'confluence',
	Atlas: 'atlas',
	Jira: 'jira',
	JiraServiceManagement: 'jira-servicedesk',
	CustomerServiceManagement: 'jira-customer-service',
} as const;
